import React, { useContext } from 'react';
import { ShopContext } from "../context/ShopContext.jsx";
import { Box, Typography, IconButton, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const CartItem = ({ item }) => {
  const { currency, updateQuantity } = useContext(ShopContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        gap: 2,
        p: 2,
        border: '1px solid #ddd',
        borderRadius: 2,
        mb: 2,
      }}
    >
      {/* Product Image */}
      <Box sx={{ width: { xs: '100%', sm: '150px' }, flexShrink: 0 }}>
        <Box
          component="img"
          src={item.product_image[0]}
          alt={item.product_name}
          sx={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: 1 }}
        />
      </Box>

      {/* Product Details */}
      <Box sx={{ flexGrow: 1, width: '100%' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {item.product_name}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
          <Typography variant="body2">{currency}{item.product_price}</Typography>
          <Typography variant="body2">Size: {item.size}</Typography>
        </Box>
      </Box>

      {/* Quantity Input and Delete Button */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField
          type="number"
          inputProps={{ min: 1 }}
          value={item.quantity}
          onChange={(e) => {
            const value = e.target.value;
            if (value === '' || parseInt(value, 10) < 1) {
              // Do nothing on invalid input to prevent API calls
            } else {
              updateQuantity(item.product_id, item.size, Number(value));
            }
          }}
          onBlur={(e) => {
            if (e.target.value === '') {
              updateQuantity(item.product_id, item.size, 1); // Reset to 1 if left empty
            }
          }}
          size="small"
          sx={{ width: 80 }}
        />
        <IconButton onClick={() => updateQuantity(item.product_id, item.size, 0)} aria-label="delete">
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CartItem;
